import styled from 'styled-components'

import { device, font } from '~/styles/utils'

export const OrderItemHeader = styled.div`
  white-space: nowrap;
  padding: 0;
  box-sizing: border-box;
  ${font('bold')};
  width: 100%;
  display: flex;
  align-items: center;
  min-width: 0;
`
const titleFontSize = {
  small: '16px',
  normal: '17px',
  large: '24px',
}

export const Title = styled.h2<{
  $variant: 'small' | 'normal' | 'large'
}>`
  display: inline-block;
  font-size: ${({ $variant }) => titleFontSize[$variant]};
  margin: 0;
  vertical-align: middle;
  text-transform: uppercase;

  line-height: normal;
  overflow: visible;
  white-space: normal;
  text-overflow: unset;

  @media ${device('notMobile')} {
    font-size: ${({ $variant }) =>
      $variant === 'small' ? titleFontSize['small'] : titleFontSize['large']};
  }
`
